import {
    AosSeverity,
    severityInkColorsMapping,
    severityToneMap,
} from 'aos-services/src/services/common/types/AosSeverity'
import { TaskCategory } from 'aos-services/src/services/tasks/types/TaskCategory'
import { Box, severityToneBackground } from 'aos-ui-universal'
import React, { FC } from 'react'

import { TaskIcon } from './TaskIcon'

interface IconTaskItemProps {
    severity: AosSeverity
    category: TaskCategory
}

export const IconTaskItem: FC<IconTaskItemProps> = props => (
    <Box
        className={`rounded p-2 shadow-md ${severityToneBackground[severityToneMap[props.severity]]}`}
    >
        <TaskIcon category={props.category} color={severityInkColorsMapping[props.severity]} />
    </Box>
)
